const TIER_KEYS = ['beginnings', 'foundations', 'beyond'];

function asList(value) {
  return Array.isArray(value) ? value : [];
}

function clampIndex(value, length) {
  const n = Number.isInteger(value) ? value : 0;
  return Math.min(Math.max(n, 0), Math.max(length - 1, 0));
}

/**
 * The pricing page's one selection model: an exam (5), a tier (3) and an
 * optional interview package (4). No package is a valid selection. The struck
 * price comes from each tier's own `was` and never depends on the package
 * (D:85-86). An empty plan list yields no exam and no tiers.
 */
export function selectOffer(plans, packages, state, labels) {
  const exams = asList(plans).filter((plan) => plan && typeof plan === 'object');
  const options = asList(packages).filter((pack) => pack && typeof pack === 'object' && pack.key);
  const exam = exams[clampIndex(state && state.ex, exams.length)] || null;
  const pkgKey = state && typeof state.pkg === 'string' ? state.pkg : '';
  const pack = options.find((option) => option.key === pkgKey) || null;
  const copy = labels || {};
  const tiers = asList(exam && exam.tiers).map((tier, index) => {
    const pending = Boolean(tier && tier.pending);
    const packageItems = pack && pack.tiers ? asList(pack.tiers[TIER_KEYS[index]]) : [];
    return {
      name: tier && tier.name ? tier.name : '',
      amount: tier && tier.amount ? tier.amount : '',
      was: tier && tier.was ? tier.was : '',
      badge: tier && tier.badge ? tier.badge : '',
      tierKey: tier && tier.tierKey ? tier.tierKey : '',
      examId: tier && tier.examId ? tier.examId : '',
      packageKey: pack ? pack.key : '',
      pending,
      items: pending ? [] : asList(tier && tier.items),
      packageItems: pending ? [] : packageItems,
      dark: index === 2,
      periodLabel: index === 0 ? (copy.freeForever || '') : (copy.paidPeriod || ''),
      cta: index === 0 ? (copy.startFree || '') : `${copy.choose || ''} ${tier && tier.name ? tier.name : ''}`.trim(),
    };
  });

  return {
    exams,
    exam,
    packages: options,
    pack,
    tiers,
    examName: exam && exam.label ? exam.label : '',
    moreHref: exam && exam.href ? exam.href : '',
  };
}

export const OXBRIDGE_PACKAGE = 'oxbridge';

/**
 * Clean the subject list the API returned: non-empty, trimmed, unique strings.
 * Anything else (an error body, an object, null) is an empty list.
 */
export function cleanSubjects(value) {
  const seen = new Set();
  const out = [];
  asList(value).forEach((item) => {
    const name = typeof item === 'string' ? item.trim() : '';
    if (name && !seen.has(name)) {
      seen.add(name);
      out.push(name);
    }
  });
  return out;
}

/** The subject a purchase carries: only an Oxbridge package has one. */
export function subjectFor(packageKey, subject) {
  return packageKey === OXBRIDGE_PACKAGE && typeof subject === 'string' ? subject : '';
}

/** True when the selection still needs a subject before it can be bought. */
export function needsSubject(packageKey, subject) {
  return packageKey === OXBRIDGE_PACKAGE && !subjectFor(packageKey, subject);
}

/** The in-flight key of one checkout: exam|tier|package|subject. */
export function busyKeyFor(tier, subject) {
  const t = tier && typeof tier === 'object' ? tier : {};
  const pkg = t.packageKey || '';
  return [t.examId || '', t.tierKey || '', pkg, subjectFor(pkg, subject)].join('|');
}
